<template>
  <div class="vacany-page">
    <title-menu
      v-if="vacancy"
      :icon="'fad fa-users'"
      :id="'candidates'"
      :title="vacancy.name"
    >
      <template slot="menu">
        <vacancy-menu
          :activePage="activePage"
          @setVacancyPage="setVacancyPage"
        >
        </vacancy-menu>
      </template>
    </title-menu>
    <div class="row m-reverse-xl">
      <div class="col mw-250">
        <div class="edit-nav-block m-hide-xl">
          <vacancy-menu
            :activePage="activePage"
            @setVacancyPage="setVacancyPage"
          >
          </vacancy-menu>
        </div>

        <edit-information
          v-if="vacancy"
          :value="vacancy"
        >
        </edit-information>

        <div class="edit-upload-image upload-image-file" v-if="vacancy">
          <label class="label-upload-image"  @click="triggerImageUpload">
          <span class="wrap-upload-image">
              <span class="helper-img"></span>
               <template v-if="tempImage">
                <img :src="tempImage" alt="Profile picture2">
              </template>
              <template v-if="picture.file && !tempImage">
                <img  :src="picture.url" alt="Profile picture3">
              </template>
          </span>
            <span class="edit-image-text">Bewerk foto</span>

          </label>
          <div v-if="picture.file || tempImage" class="rotate-photo-grid">
            <span class="edit-image-text rotate-button fas fa-undo" @click="rotateImage(-90)">
            </span>
            <span class="edit-image-text rotate-button fas fa-redo" @click="rotateImage(90)">
            </span>
          </div>
          <picture-input
            class="d-none"
            ref="pictureInput"
            width="400"
            height="250"
            :crop="false"
            accept="image/*"
            @change="handleFileChange">
          </picture-input>

        </div>

      </div>

      <div class="col">
        <component
          :is="activePage"
          :vacancy="vacancy"
          :id="id"
          v-if="vacancyLoaded"
          @unsavedChanges="hasUnsavedChanges($event)"
        ></component>
      </div>

    </div>
  </div>
</template>

<script>
  import titleMenu from '../../components/titleMenu'
  import vacancyMenu from '../../components/vacancy/vacancyMenu'
  import editInformation from './../../components/editInformation'
  import {mapGetters} from 'vuex';
  import vacancyInfo from '../../components/vacancy/vacancyInfo';
  import vacancyCandidatePlacing from '../../components/vacancy/vacancyCandidatePlacing';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import {imageOrientation} from './../../components/mixins/imageOrientation.js';
  import axios from "axios";
  import {rotateBase64} from '../../functions/rotateBase64'

  export default {
    mixins: [swalModals, imageOrientation],
    props: ['id'],
    components: {
      titleMenu,
      vacancyMenu,
      editInformation,
      vacancyInfo,
      vacancyCandidatePlacing

    },
    data() {
      return {
        disableNavigation: false,
        activePage: 'vacancyInfo',
        renderedComponent: true,
        vacancyLoaded: false,
        vacancyCopy: null,
        vacancy: null,
        tempImage: null,
        fileUpload: null,
        picture: {
          file: null,
          name: 'vacancyImage'
        }
      };
    },
    methods: {
      async rotateImage(degrees) {
        if (typeof this.picture.file === 'string') {
          const file = await axios.get(this.picture.url, {responseType: 'blob'});
          this.picture.file = file.data;
        }
        var reader = new FileReader();
        reader.readAsDataURL(this.picture.file);
        reader.onload = () => {
          const base64 = reader.result;
          rotateBase64(base64, degrees, (rotatedImg) => {
            this.picture.file = this.dataURItoBlob(rotatedImg);
            this.tempImage = rotatedImg;
            this.picture.path = '/candidates/' + this.id + '/';
            delete this.picture.metaData;
            this.$FB_UPLOADER.upload(this.picture).then(() => {
              this.$toasted.global.successRequest({
                message: 'Afbeelding geroteerd'
              });
              this.$store.commit('setLoading', false);
            }).catch(() => {
              this.$toasted.global.failedRequest();
            });
          });
        }
      },
      hasUnsavedChanges(event) {
        this.disableNavigation = event;
      },
      setVacancyPage(page) {
        if (this.disableNavigation) {
          this.swalUnsavedChanges().then(result => {
            if (result.value) {
              this.vacancy = this.vacancyCopy;
              this.activePage = page;
              this.disableNavigation = false;
            }
          });
        } else {
          this.activePage = page;
        }
      },
      triggerImageUpload() {
        this.$refs.pictureInput.$refs.fileInput.click()
      },
      handleFileChange() {
        this.$store.commit('setLoading', true)
        this.picture.file = this.$refs.pictureInput.file

        let file = this.picture.file

        let ImgCheck = this.$refs.pictureInput
        ImgCheck.getEXIFOrientation(file, (orientation) => {

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              var base64 = reader.result;
              this.resetOrientation(base64, orientation, (resetBase64Image) => {

                this.picture.file = this.dataURItoBlob(resetBase64Image);
                this.tempImage = resetBase64Image
                this.picture.path = '/vacancies/' + this.id + '/';
                delete this.picture.metaData;

                this.$FB_UPLOADER.upload(this.picture).then(() => {
                  this.$store.dispatch('vacancies/set', this.vacancy).then(() => {
                    this.$store.commit('setLoading', false);
                  });
                }).catch(() => {
                  this.$toasted.global.failedRequest();
                });
              });
            }
          }
        )
      },
    },
    computed: {
      ...mapGetters('customers', ['getCustomers']),
      ...mapGetters('candidates', ['getCandidates'])
    },
    beforeRouteLeave(to, from, next) {
      if (this.disableNavigation) {
        this.swalUnsavedChanges().then(result => {
          if (result.value) {
            next();
            this.customer = this.customerCopy;
          }
        });
      } else {
        next();
      }
    },
    created() {
      let id = this.id;
      var self = this;
      var ref = this.$FB_STORAGE.ref('');
      var documentList = ref.child('vacancies/' + id);
      documentList.listAll().then(function (itemList) {
        itemList.items.forEach(function (itemRef) {
          itemRef.getDownloadURL().then((documentUrl) => {
            self.doc = documentUrl
            self.picture = {
              name: 'vacancyImage',
              file: documentUrl,
              url: documentUrl
            }
          })
        })
      }).catch(function (error) {
        console.log(error)
      });
      this.$store.dispatch('vacancies/fetchById', id).then(res => {
        this.vacancy = Object.assign({}, res);
        this.vacancyLoaded = true;
        this.vacancyCopy = Object.assign({}, res);
      });
    }
  };
</script>


<style lang="scss">
  .rotate-button {
    padding-top: 1rem;
  }

  .rotate-photo-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    background-color: white;
  }

</style>